<script>
import { Bar } from "vue-chartjs";
import "@/plugins/chart";

const PRIMARY_AXIS = 'primary'
const SECONDARY_AXIS = 'secondary'

export default {
    name: "MixedTrendChart",
    extends: Bar,
    props: {
        labels: {
            type: Array,
            default: () => [],
        },
        series: {
            type: Array,
            default: () => [],
        },
        moneyFormatter: {
            type: Function,
            default: null,
        },
    },
    computed: {
        data(vm = this) {
            const dark = vm.$vuetify.theme.dark
            return {
                labels: vm.labels,
                datasets: vm.series.map((item, i) => {
                    const isBar = i === 0
                    return {
                        type: isBar ? 'bar' : 'line',
                        label: item.label,
                        data: item.data,
                        backgroundColor: isBar ? `${item.color}99` : 'transparent',
                        borderColor: item.color,
                        borderWidth: isBar ? 1 : 2.5,
                        pointBackgroundColor: item.color,
                        pointBorderColor: dark ? '#080A0E' : '#FFFFFF',
                        pointBorderWidth: 2,
                        pointRadius: isBar ? 0 : 4,
                        fill: false,
                        lineTension: 0.3,
                        spanGaps: true,
                        barPercentage: 0.6,
                        categoryPercentage: 0.7,
                        yAxisID: item.money ? SECONDARY_AXIS : PRIMARY_AXIS,
                    }
                }),
            }
        },
        options(vm = this) {
            const theme = vm.$vuetify.theme.currentTheme
            const money = value => (vm.moneyFormatter ? vm.moneyFormatter(value) : value)
            const tick = {
                fontColor: theme.txtMuted,
                fontFamily: '"Outfit", sans-serif',
                fontSize: 10,
                beginAtZero: true,
                maxTicksLimit: 5,
            }
            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                layout: { padding: { top: 16 } },
                scales: {
                    xAxes: [{
                        gridLines: { display: false },
                        ticks: { ...tick, fontStyle: 'bold' },
                    }],
                    yAxes: [
                        {
                            id: PRIMARY_AXIS,
                            position: 'left',
                            gridLines: { color: theme.outline, drawBorder: false, zeroLineColor: theme.outline },
                            ticks: tick,
                        },
                        {
                            id: SECONDARY_AXIS,
                            position: 'right',
                            display: false,
                            gridLines: { display: false },
                            ticks: { ...tick, callback: value => money(value) },
                        },
                    ],
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    backgroundColor: theme.surface2,
                    titleFontColor: theme.txtPrimary,
                    bodyFontColor: theme.txtSecondary,
                    borderColor: theme.outline,
                    borderWidth: 1,
                    cornerRadius: 8,
                    xPadding: 10,
                    yPadding: 8,
                    titleFontFamily: '"Outfit", sans-serif',
                    bodyFontFamily: '"Outfit", sans-serif',
                    filter: tooltipItem => tooltipItem.yLabel !== null && tooltipItem.yLabel !== undefined,
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const dataset = data.datasets[tooltipItem.datasetIndex] || {}
                            const source = vm.series[tooltipItem.datasetIndex] || {}
                            const value = tooltipItem.yLabel
                            const text = source.money ? money(value) : `${value}${source.suffix || ''}`
                            return `${dataset.label}: ${text}`
                        },
                    },
                },
            }
        },
    },
    data() {
        return {
            renderKey: null,
        }
    },
    mounted() {
        this.draw()
    },
    methods: {
        draw() {
            const vm = this
            const key = JSON.stringify({
                labels: vm.labels,
                series: vm.series,
                dark: vm.$vuetify.theme.dark,
            })
            if (key === vm.renderKey) return
            vm.renderKey = key
            vm.renderChart(vm.data, vm.options)
        },
    },
    watch: {
        data() {
            this.draw()
        },
        options() {
            this.draw()
        },
    },
}
</script>
